export default __webpack_public_path__ + "content/media/35.1a036ff6.jpg";